<template>
    <div id="relatedinformation">
        <Banner
            :title="differentRouter.title"
            :breadcrumbs="differentRouter.breadcrumbs"
            :type="differentRouter.type"
        ></Banner>
        <div class="container">
            <div class="center_title">
                <Title
                    :en="title.en"
                    :chtFirst="title.chtFirst"
                    :chtSecond="title.chtSecond"
                    :center="true"
                ></Title>
            </div>
            <section class="download_list">
                <div class="item">
                    <div class="videocard download_item" >
                        <img :src="`http://img.youtube.com/vi/${otherData.trsvideo.thumbnail}/sddefault.jpg`" />
                        <!-- <div class="date">{{data.Date}}</div> -->
                        <div class="title">{{otherData.trsvideo.title}}</div>
                        <div class="content">
                            <div class="btn">
                <a
                    class="Orange_btn"
                    :class="{'islogin':isallow}"
                    href="javascript:;"
                    @click="toPath(otherData.trsvideo.file)"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g id="original-icon" :fill="isallow?'#ffffff':'#cccccc'">
                                <g id="surface1">
                                    <path
                                        d="M86,10.32c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,24.08c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,37.84c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM85.6775,51.4925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v74.175l-21.6075,-21.6075c-0.83312,-0.86 -2.05594,-1.22281 -3.225,-0.9675c-1.29,0.22844 -2.32469,1.16906 -2.6875,2.41875c-0.36281,1.26313 0.01344,2.60688 0.9675,3.49375l27.09,26.9825c0.12094,0.18813 0.26875,0.37625 0.43,0.5375c0.06719,0.08063 0.13438,0.14781 0.215,0.215c0.20156,0.16125 0.41656,0.30906 0.645,0.43c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.04031,0 0.06719,0 0.1075,0c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.13438,0.04031 0.28219,0.08063 0.43,0.1075c0.36281,0.05375 0.71219,0.05375 1.075,0c0.06719,0 0.14781,0 0.215,0c0.29563,-0.06719 0.59125,-0.17469 0.86,-0.3225c0.45688,-0.22844 0.86,-0.56437 1.1825,-0.9675l27.305,-27.1975c1.37063,-1.37062 1.37063,-3.57437 0,-4.945c-1.37062,-1.37062 -3.57437,-1.37062 -4.945,0l-21.6075,21.6075v-74.175c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM6.88,113.52v41.28c0,5.65719 4.66281,10.32 10.32,10.32h137.6c5.65719,0 10.32,-4.66281 10.32,-10.32v-41.28h-6.88v41.28c0,1.94844 -1.49156,3.44 -3.44,3.44h-137.6c-1.94844,0 -3.44,-1.49156 -3.44,-3.44v-41.28z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>前往觀看</span>
                </a>
            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="videocard download_item" >
                        <img :src="otherData.EYLEA.file" />
                        <!-- <div class="date">{{data.Date}}</div> -->
                        <div class="title">{{otherData.EYLEA.title}}</div>
                        <div class="content">
                            <div class="btn">
                <a
                    class="Orange_btn"
                    :class="{'islogin':isallow}"
                    href="javascript:;"
                    @click="download(otherData.EYLEA.file, 'jpg')"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g id="original-icon" :fill="isallow?'#ffffff':'#cccccc'">
                                <g id="surface1">
                                    <path
                                        d="M86,10.32c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,24.08c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,37.84c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM85.6775,51.4925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v74.175l-21.6075,-21.6075c-0.83312,-0.86 -2.05594,-1.22281 -3.225,-0.9675c-1.29,0.22844 -2.32469,1.16906 -2.6875,2.41875c-0.36281,1.26313 0.01344,2.60688 0.9675,3.49375l27.09,26.9825c0.12094,0.18813 0.26875,0.37625 0.43,0.5375c0.06719,0.08063 0.13438,0.14781 0.215,0.215c0.20156,0.16125 0.41656,0.30906 0.645,0.43c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.04031,0 0.06719,0 0.1075,0c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.13438,0.04031 0.28219,0.08063 0.43,0.1075c0.36281,0.05375 0.71219,0.05375 1.075,0c0.06719,0 0.14781,0 0.215,0c0.29563,-0.06719 0.59125,-0.17469 0.86,-0.3225c0.45688,-0.22844 0.86,-0.56437 1.1825,-0.9675l27.305,-27.1975c1.37063,-1.37062 1.37063,-3.57437 0,-4.945c-1.37062,-1.37062 -3.57437,-1.37062 -4.945,0l-21.6075,21.6075v-74.175c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM6.88,113.52v41.28c0,5.65719 4.66281,10.32 10.32,10.32h137.6c5.65719,0 10.32,-4.66281 10.32,-10.32v-41.28h-6.88v41.28c0,1.94844 -1.49156,3.44 -3.44,3.44h-137.6c-1.94844,0 -3.44,-1.49156 -3.44,-3.44v-41.28z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>檔案下載</span>
                </a>
            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="download_list">
                <div class="item" v-for="(item,index) in downloadData" :key="index">
                    <div class="videocard download_item" >
                        <img :src="defaultImg" />
                        <!-- <div class="date">{{data.Date}}</div> -->
                        <div class="title">{{item.title}}</div>
                        <div class="content">
                            <div class="btn" v-if="index != 2">
                <a
                    class="Orange_btn"
                    :class="{'islogin':isallow}"
                    href="javascript:;"
                    @click="download(item.file)"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g id="original-icon" :fill="isallow?'#ffffff':'#cccccc'">
                                <g id="surface1">
                                    <path
                                        d="M86,10.32c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,24.08c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,37.84c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM85.6775,51.4925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v74.175l-21.6075,-21.6075c-0.83312,-0.86 -2.05594,-1.22281 -3.225,-0.9675c-1.29,0.22844 -2.32469,1.16906 -2.6875,2.41875c-0.36281,1.26313 0.01344,2.60688 0.9675,3.49375l27.09,26.9825c0.12094,0.18813 0.26875,0.37625 0.43,0.5375c0.06719,0.08063 0.13438,0.14781 0.215,0.215c0.20156,0.16125 0.41656,0.30906 0.645,0.43c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.04031,0 0.06719,0 0.1075,0c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.13438,0.04031 0.28219,0.08063 0.43,0.1075c0.36281,0.05375 0.71219,0.05375 1.075,0c0.06719,0 0.14781,0 0.215,0c0.29563,-0.06719 0.59125,-0.17469 0.86,-0.3225c0.45688,-0.22844 0.86,-0.56437 1.1825,-0.9675l27.305,-27.1975c1.37063,-1.37062 1.37063,-3.57437 0,-4.945c-1.37062,-1.37062 -3.57437,-1.37062 -4.945,0l-21.6075,21.6075v-74.175c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM6.88,113.52v41.28c0,5.65719 4.66281,10.32 10.32,10.32h137.6c5.65719,0 10.32,-4.66281 10.32,-10.32v-41.28h-6.88v41.28c0,1.94844 -1.49156,3.44 -3.44,3.44h-137.6c-1.94844,0 -3.44,-1.49156 -3.44,-3.44v-41.28z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>檔案下載</span>
                </a>
            </div>
            <div class="btn" v-else>
                <a
                    class="Orange_btn mb-1"
                    :class="{'islogin':isallow}"
                    :href="item.file[0]"
                    download="IIS Setup 1.2.13.rar"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g id="original-icon" :fill="isallow?'#ffffff':'#cccccc'">
                                <g id="surface1">
                                    <path
                                        d="M86,10.32c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,24.08c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,37.84c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM85.6775,51.4925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v74.175l-21.6075,-21.6075c-0.83312,-0.86 -2.05594,-1.22281 -3.225,-0.9675c-1.29,0.22844 -2.32469,1.16906 -2.6875,2.41875c-0.36281,1.26313 0.01344,2.60688 0.9675,3.49375l27.09,26.9825c0.12094,0.18813 0.26875,0.37625 0.43,0.5375c0.06719,0.08063 0.13438,0.14781 0.215,0.215c0.20156,0.16125 0.41656,0.30906 0.645,0.43c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.04031,0 0.06719,0 0.1075,0c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.13438,0.04031 0.28219,0.08063 0.43,0.1075c0.36281,0.05375 0.71219,0.05375 1.075,0c0.06719,0 0.14781,0 0.215,0c0.29563,-0.06719 0.59125,-0.17469 0.86,-0.3225c0.45688,-0.22844 0.86,-0.56437 1.1825,-0.9675l27.305,-27.1975c1.37063,-1.37062 1.37063,-3.57437 0,-4.945c-1.37062,-1.37062 -3.57437,-1.37062 -4.945,0l-21.6075,21.6075v-74.175c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM6.88,113.52v41.28c0,5.65719 4.66281,10.32 10.32,10.32h137.6c5.65719,0 10.32,-4.66281 10.32,-10.32v-41.28h-6.88v41.28c0,1.94844 -1.49156,3.44 -3.44,3.44h-137.6c-1.94844,0 -3.44,-1.49156 -3.44,-3.44v-41.28z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>安裝軟體</span>
                </a>
                <a
                    class="Orange_btn mb-1"
                    :class="{'islogin':isallow}"
                    :href="item.file[1]"
                    download="操作手冊"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g id="original-icon" :fill="isallow?'#ffffff':'#cccccc'">
                                <g id="surface1">
                                    <path
                                        d="M86,10.32c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,24.08c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,37.84c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM85.6775,51.4925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v74.175l-21.6075,-21.6075c-0.83312,-0.86 -2.05594,-1.22281 -3.225,-0.9675c-1.29,0.22844 -2.32469,1.16906 -2.6875,2.41875c-0.36281,1.26313 0.01344,2.60688 0.9675,3.49375l27.09,26.9825c0.12094,0.18813 0.26875,0.37625 0.43,0.5375c0.06719,0.08063 0.13438,0.14781 0.215,0.215c0.20156,0.16125 0.41656,0.30906 0.645,0.43c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.04031,0 0.06719,0 0.1075,0c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.13438,0.04031 0.28219,0.08063 0.43,0.1075c0.36281,0.05375 0.71219,0.05375 1.075,0c0.06719,0 0.14781,0 0.215,0c0.29563,-0.06719 0.59125,-0.17469 0.86,-0.3225c0.45688,-0.22844 0.86,-0.56437 1.1825,-0.9675l27.305,-27.1975c1.37063,-1.37062 1.37063,-3.57437 0,-4.945c-1.37062,-1.37062 -3.57437,-1.37062 -4.945,0l-21.6075,21.6075v-74.175c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM6.88,113.52v41.28c0,5.65719 4.66281,10.32 10.32,10.32h137.6c5.65719,0 10.32,-4.66281 10.32,-10.32v-41.28h-6.88v41.28c0,1.94844 -1.49156,3.44 -3.44,3.44h-137.6c-1.94844,0 -3.44,-1.49156 -3.44,-3.44v-41.28z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>操作手冊</span>
                </a>
                <a
                    class="Orange_btn mb-1"
                    :class="{'islogin':isallow}"
                    :href="item.file[2]"
                    download="安裝手冊"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g id="original-icon" :fill="isallow?'#ffffff':'#cccccc'">
                                <g id="surface1">
                                    <path
                                        d="M86,10.32c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,24.08c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,37.84c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM85.6775,51.4925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v74.175l-21.6075,-21.6075c-0.83312,-0.86 -2.05594,-1.22281 -3.225,-0.9675c-1.29,0.22844 -2.32469,1.16906 -2.6875,2.41875c-0.36281,1.26313 0.01344,2.60688 0.9675,3.49375l27.09,26.9825c0.12094,0.18813 0.26875,0.37625 0.43,0.5375c0.06719,0.08063 0.13438,0.14781 0.215,0.215c0.20156,0.16125 0.41656,0.30906 0.645,0.43c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.04031,0 0.06719,0 0.1075,0c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.13438,0.04031 0.28219,0.08063 0.43,0.1075c0.36281,0.05375 0.71219,0.05375 1.075,0c0.06719,0 0.14781,0 0.215,0c0.29563,-0.06719 0.59125,-0.17469 0.86,-0.3225c0.45688,-0.22844 0.86,-0.56437 1.1825,-0.9675l27.305,-27.1975c1.37063,-1.37062 1.37063,-3.57437 0,-4.945c-1.37062,-1.37062 -3.57437,-1.37062 -4.945,0l-21.6075,21.6075v-74.175c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM6.88,113.52v41.28c0,5.65719 4.66281,10.32 10.32,10.32h137.6c5.65719,0 10.32,-4.66281 10.32,-10.32v-41.28h-6.88v41.28c0,1.94844 -1.49156,3.44 -3.44,3.44h-137.6c-1.94844,0 -3.44,-1.49156 -3.44,-3.44v-41.28z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>安裝手冊</span>
                </a>
                <a
                    class="Orange_btn"
                    :class="{'islogin':isallow}"
                    href="https://drive.google.com/drive/folders/1tzHpaNLrFqWqW1FPoploeUJtLjjZlWEh?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g id="original-icon" :fill="isallow?'#ffffff':'#cccccc'">
                                <g id="surface1">
                                    <path
                                        d="M86,10.32c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,24.08c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,37.84c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM85.6775,51.4925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v74.175l-21.6075,-21.6075c-0.83312,-0.86 -2.05594,-1.22281 -3.225,-0.9675c-1.29,0.22844 -2.32469,1.16906 -2.6875,2.41875c-0.36281,1.26313 0.01344,2.60688 0.9675,3.49375l27.09,26.9825c0.12094,0.18813 0.26875,0.37625 0.43,0.5375c0.06719,0.08063 0.13438,0.14781 0.215,0.215c0.20156,0.16125 0.41656,0.30906 0.645,0.43c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.04031,0 0.06719,0 0.1075,0c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.13438,0.04031 0.28219,0.08063 0.43,0.1075c0.36281,0.05375 0.71219,0.05375 1.075,0c0.06719,0 0.14781,0 0.215,0c0.29563,-0.06719 0.59125,-0.17469 0.86,-0.3225c0.45688,-0.22844 0.86,-0.56437 1.1825,-0.9675l27.305,-27.1975c1.37063,-1.37062 1.37063,-3.57437 0,-4.945c-1.37062,-1.37062 -3.57437,-1.37062 -4.945,0l-21.6075,21.6075v-74.175c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM6.88,113.52v41.28c0,5.65719 4.66281,10.32 10.32,10.32h137.6c5.65719,0 10.32,-4.66281 10.32,-10.32v-41.28h-6.88v41.28c0,1.94844 -1.49156,3.44 -3.44,3.44h-137.6c-1.94844,0 -3.44,-1.49156 -3.44,-3.44v-41.28z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>REST宣傳Video<br>及相關功能介紹影片</span>
                </a>
            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import Common from "@/common";

export default {
    name: "relatedinformation",
    props: {
        isallow: {
            type: Boolean
        },
        // islogin: {
        //     type: Boolean
        // },
    },
    data() {
        return {
            videos: [],
            totalPage: 1,
            nowPage: 1,
            videoId: "",
            busy: false,
            isLoading: false,
            title: {
                en: "",
                chtFirst: "",
                chtSecond: ""
            },
            defaultImg: require("@/assets/notfound.png"),
            otherData: {
                EYLEA: {
                    title: 'EYLEA 8mg 持久控制疾病',
                    file: '/static/images/eylea/EYLEA.jpg',
                },
                trsvideo: {
                    title: '最新視網膜疾病治療長效藥物',
                    file: 'https://youtu.be/PzDDL2dG57k',
                    thumbnail: 'PzDDL2dG57k'
                }
            },
            downloadData: [
                {
                    title: '拜耳 Treat and Extend 眼科醫師問答集 (供醫師參考)',
                    file: '/static/pdf/拜耳_Treat and Extend 眼科醫師問答集 (供醫師參考).pdf',
                },
                {
                    title: '拜耳 Treat and Extend 病患討論指南 (與病患溝通的要點，供醫師參考)',
                    file: '/static/pdf/拜耳_Treat and Extend 病患討論指南 (與病患溝通的要點，供醫師參考).pdf',
                },
                {
                    title: 'REST視網膜疾病健保給付及病人資訊整合軟體',
                    file: ['/static/pdf/IIS Setup 1.2.13.rar','/static/pdf/視網膜疾病健保給付及病人資訊整合軟體操作手冊.docx','/static/pdf/視網膜疾病健保給付及病人資訊整合軟體安裝手冊（含設定）.docx'],
                }
            ],
        };
    },
    methods: {
        back() {
            window.history.go(-1);
        },
        download(url,type) {
            const vm = this;
            if(!vm.isallow) {
                return false
            } else if (type=='jpg') {
                window.open(url, '_blank')
            }
            else {
                Common.download(url, { type: "pdf" });
            }   
        },
        toPath(url) {
            const vm = this
            if(!vm.isallow) {
                return false
            } else {
                window.open(url)
            }
        }
    },
    computed: {
        differentRouter() {
            const vm = this;
                return {
                    title: "會員專屬資訊",
                    breadcrumbs: [
                        {
                            url: "/",
                            title: "首頁"
                        },
                        {
                            url: "/Conference/RelatedInformation",
                            title: "會員專屬資訊"
                        },
                    ],
                    // type: "information"
                };
        }
    },
    created() {
        const vm = this;
        if (!vm.isallow) {
            vm.$swal({
                type: "warning",
                text: "要成為付費會員才能觀看影片或下載資料",
                confirmButtonText: "確定"
            }).then(() => {
                location.href = "/";
            });
        }
        vm.title = {
                en: "Related information",
                chtFirst: "會員",
                chtSecond: "專屬資訊"
        };
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#relatedinformation .remark {
    margin-bottom: 30px;
    text-align: center;
}
#relatedinformation .list_box {
    margin-bottom: 60px;
}
#relatedinformation .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
}
#relatedinformation .list::after {
    content: "";
    flex: 0 0 30%;
    width: 30%;
    max-width: 350px;
}
#relatedinformation .list .item {
    width: 30%;
    max-width: 350px;
    margin-bottom: 25px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    padding-bottom: 20px;
}
#relatedinformation .detail .video_box {
    border: 8px solid #eee;
    padding: 30px 10px;
}
#relatedinformation .detail .video_box .date {
    color: #666;
    padding: 10px 20px;
    letter-spacing: 2px;
    font-size: 1.1rem;
}
#relatedinformation .detail .video_box .title {
    color: #666;
    font-size: 1.4rem;
    padding: 0 20px 20px;
    letter-spacing: 2px;
    line-height: 1.5;
    border-bottom: 1px solid #aaa;
    margin-bottom: 20px;
}
#relatedinformation .detail .video_box .video {
    width: 90%;
    margin: auto;
    padding: 40px 0;
}
#relatedinformation .detail .video_box .video video {
    width: 100%;
}
#relatedinformation .detail .video_box .remark {
    color: #666;
    letter-spacing: 2px;
    line-height: 1.2;
}
#relatedinformation .detail .video_box .download {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    width: 165px;
}
@media screen and (max-width: 992px) {
    #relatedinformation .list .item {
        width: 48%;
        max-width: none;
    }
}
@media screen and (max-width: 767px) {
    #relatedinformation .list .item {
        width: 100%;
        margin: 0 auto 30px;
        max-width: none;
    }
}

.download_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.download_list:after {
    content: "";
    flex: 0 0 30%;
    width: 30%;
    max-width: 350px;
}

/* .download_item {
    flex: 33.33333%;
} */

.download_item img{
    width: 100%;
    border: 4px solid #a59b92;
    font-size: 0;
    position: relative;
    display: block;
}

.download_item .title {
    padding: 10px;
    /* text-align: center; */
    line-height: 1.5;
    letter-spacing: 2px;
}

.download_item .content {
    padding: 10px;
}

.download_list .item {
    width: 30%;
    max-width: 350px;
    /* flex: 30%; */
    margin-bottom: 25px;
    box-shadow: 0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);
    padding-bottom: 20px;
}
@media screen and (max-width: 420px) {
.download_list .item {
    width: 100%;
}
}
/* 
.imgbtncard .title {
    padding: 15px 0;
    text-align: center;
    line-height: 1.5;
    letter-spacing: 2px;
} */

.mb-1 {
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/download.vue